import { UPLOAD_ATTACHMENTS } from "../action.js";

export const uploadAttachments = (newFiles) => {
    return (dispatch) => {
        dispatch({ type: UPLOAD_ATTACHMENTS, payload: newFiles });
    };
};